const { default: styled } = require('styled-components')

const Wrapper = styled.div`
  width: ${({ width }) => width || '250px'};
  border: ${({ border, isMostPopular }) =>
    border ? `1px solid ${isMostPopular ? '#f05' : '#e0e0e0'}` : 'none'};
  border-radius: 10px;
  padding: 25px 20px;
  .headerCard {
    position: relative;
    min-height: 380px;
    max-height: 380px;
  }
  .footer {
    postion: absolute;
    bottom: 0;
  }
`

const ContentWrapper = styled.div`
  height: ${(props) => (props?.scaleHeight ? 'calc(100% - 200px)' : 'auto')};
  .feature-group {
    height: 25px;
  }
  .feature-name {
    height: 25px;
    margin-bottom: 14px;
  }
  .availablity-icon {
    height: 25px;
  }
`

export { Wrapper, ContentWrapper }
